import { Injectable } from '@angular/core';
import { Ability } from '../models/ability';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AbilityService {

  constructor( private http:HttpClient ) { }

  getAbilities() : Promise<Ability[]> {
    return this.http.get<Ability[]>('/api/auth/ability')
      .toPromise();
  }

  postAbility(ability:Ability) : Promise<Ability> {
    return this.http.post<Ability>('/api/auth/ability', ability).toPromise();
  }

  putAbility(ability:Ability) : Promise<Ability> {
    return this.http.post<Ability>('/api/auth/ability/' + ability.id + '/edit', ability).toPromise();
  }

}
